/**
 * An enumeration of options for representing user feature flag settings.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const FeatureFlagOptions = {
    /** Indicates that the feature is always enabled */
    enabled: "enabled",
    /** Indicates that the feature is always disabled */
    disabled: "disabled",
    /** Indicates that the user has opted into a feature. The user can opt out of the feature. */
    optIn: "optIn",
    /** Indicates that the user has opted out of a feature. The user can opt back into the feature. */
    optOut: "optOut",
    /** Indicates that the user has made no preference known for the feature. */
    noPref: "noPref"
};
